import React from 'react';
import PropTypes from 'prop-types';

import Avatar from '@decisiv/ui-components/lib/components/Avatar';
import { P } from '@decisiv/ui-components/lib/components/Typography';

import PlainLink from '../../shared/PlainLink';
import { editUserPath } from '../../shared/paths';
import { UserIdentity, UserNames } from './styles';

/**
 * The USERS column: avatar, name, email.
 *
 * The name links to the user's detail page (PD-4068). A nameless user falls back
 * to plain text rather than rendering an empty link with nothing to click.
 *
 * PlainLink rather than KeyDS `Link`: the table re-renders on every fetch, sort and
 * filter, and `Link` cannot survive a re-render on React 16 — see PlainLink.
 *
 * Avatar derives its initials from the name it is given, so no initials come
 * over the wire.
 */
function UserCell({ email, id, name }) {
  return (
    <UserIdentity>
      <Avatar email={email} name={name} />
      <UserNames>
        {name ? (
          <PlainLink href={editUserPath(id)}>{name}</PlainLink>
        ) : (
          <P weight="semibold">{name}</P>
        )}
        <P shade={1} size="small">
          {email}
        </P>
      </UserNames>
    </UserIdentity>
  );
}

UserCell.propTypes = {
  email: PropTypes.string,
  id: PropTypes.number.isRequired,
  name: PropTypes.string,
};

UserCell.defaultProps = {
  email: undefined,
  name: undefined,
};

export default UserCell;
